import * as React from 'react';

function SvgSearch(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
      <path d="M13.214 12.356L9.157 8.3c.63-.814.97-1.81.97-2.857a4.66 4.66 0 00-1.373-3.314A4.653 4.653 0 005.439.755a4.66 4.66 0 00-3.314 1.373A4.65 4.65 0 00.752 5.442c0 1.252.489 2.43 1.373 3.314A4.65 4.65 0 005.44 10.13a4.65 4.65 0 002.855-.969l4.058 4.056a.13.13 0 00.14.028.129.129 0 00.041-.028l.681-.68a.127.127 0 00.038-.09.127.127 0 00-.038-.09zm-5.3-4.439A3.481 3.481 0 015.44 8.942a3.481 3.481 0 01-2.475-1.025A3.481 3.481 0 011.94 5.442c0-.934.365-1.814 1.025-2.475A3.481 3.481 0 015.44 1.942c.935 0 1.815.363 2.475 1.025A3.481 3.481 0 018.94 5.442c0 .935-.364 1.814-1.025 2.475z" />
    </svg>
  );
}

export default SvgSearch;
